import { usePermissionContext, useWorkspaceContext } from '../context';

export enum CandidateAtsAccess {
  MAP_CANDIDATE = 'MAP_CANDIDATE',
  SUBMIT_CANDIDATE = 'SUBMIT_CANDIDATE',
  IMPORT_MAPPINGS_TO_JOB = 'IMPORT_MAPPINGS_TO_A_JOB',
  IMPORT_SUBMISSION_TO_JOB = 'IMPORT_SUBMISSION_TO_A_JOB',
  LOCAL_IMPORT = 'LOCAL_IMPORT',
  EXCEL_IMPORT = 'EXCEL_IMPORT',
  GDRIVE_IMPORT = 'GDRIVE_IMPORT',
  TALENTPOOL_DOWNLOAD = 'TALENTPOOL_DOWNLOAD',
  JOBCRM_DOWNLOAD = 'JOBCRM_DOWNLOAD',
  SUBMISSIONS_DOWNLOAD = 'SUBMISSIONS_DOWNLOAD',
  PIPELINE_DOWNLOAD = 'PIPELINE_DOWNLOAD',
  POTENTIAL_REVENUE_VISIBILITY = 'POTENTIAL_REVENUE_VISIBILITY',
}

export const useCandidateAts = (action: CandidateAtsAccess) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();

  return (
    workspace.owns ||
    (workspace.role &&
      permissionContext.isAuthorized &&
      permissionContext.isAuthorized('CANDIDATE_BOARD', action, [workspace.role]))
  );
};
